module.exports = __webpack_public_path__ + "assets/img/beginner.43920485.svg";